import React, { useEffect } from 'react';
import './VendorBilling.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBillingHistory } from "../../../Services/Vendor/VendorApi/VendorApi"
import Chip from '@mui/material/Chip';
function VendorsBilling() {
    const dispatch = useDispatch()
    const userId = localStorage.getItem("user_id")
    const { data } = useSelector((state) => state.fetchBillingHistory)
    useEffect(() => {
        dispatch(fetchBillingHistory(userId))
    }, [dispatch, userId])
    return (
        <div className="community-section">
            <div className="community-inner-wrapper d-flex align-items-center justify-content-between">
                <div className="add-new-community d-flex justify-content-between align-items-center mb-0">
                    <div className="community-heading">Billing</div>
                </div>
                <div className='category-block d-flex gap-2 align-items-center'>
                    <div><b>Billing Period:</b></div>
                    <div className="dropdown-filter">
                        <select>
                            <option value="" disabled selected>2025</option>
                            <option value="option1">2026</option>
                            <option value="option2">2027</option>
                            <option value="option3">2028</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="all-commmunities-table">
                {/* <div className='billing-title allcommunities'>
                    Client Search
                </div> */}
                {/* <div className='input-search mt-2'>
                    <input type="text" placeholder="Start Typing here..." />
                </div> */}
                <div className='payments-table billing'>
                    <table className="table mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Type</th>
                                <th scope="col">City</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Payment Status</th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {data?.data?.length > 0 ? (data?.data?.map((bill, index) => (
                                <tr key={bill?.id + index}>
                                    <td>{bill?.created_at}</td>
                                    <td>{bill?.product_name}</td>
                                    <td>{bill?.city_name}</td>
                                    <td>{bill?.price_amount}</td>
                                    <td>{<Chip label={bill?.payment_status} size="small" color={bill?.payment_status === "paid" ? "success" : bill?.payment_status === "cancelled" ? "error" : "warning"} variant="outlined" />}</td>
                                </tr>
                            ))) : (
                                <tr>
                                    <td>No Payments Found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default VendorsBilling;